import { useContext } from "react";

import { MenusContext } from "./Menus.context";

export function useMenusState() {
  return useContext(MenusContext);
}
